// extracted by mini-css-extract-plugin
export default {"donatePage":"donatePage__donatePage--Sr8dn"};